'use client'

import dynamic from 'next/dynamic'
import Image from 'next/image'
import Link from 'next/link'
import { Grid, Typography } from '@mui/material'

// Types
import type { CardProps } from '@/types/components/molecules/cards'

// Helpers
import { useTranslation } from '@/helpers/i18n/client'

// Components
const RedButtonAtom = dynamic(() => import('@/components/atoms/buttons/red'))

const LearnCardMole = (props: CardProps) => {
	// Props
	const { lng, title, image, link, description, size } = props

	// Variables
	const { t } = useTranslation(lng)

	return (
		<Grid size={{ xs: 12, md: size === 'small' ? 4 : size === 'medium' ? 6 : 12 }}>
			<Link href={`/${lng}${link}`}>
				<Grid container direction="column" alignItems="stretch" spacing={2.5} position="relative" height={{ md: 1 }} p={1.5} bgcolor="#fefcf8" borderRadius={2}>
					<Grid
						size={12}
						display="inline-flex"
						borderRadius={1}
						position="relative"
						overflow="hidden"
						sx={{
							height: { xs: 320, md: 240, lg: 360 },
							bgcolor: '#624d44',
							'& img': {
								width: 1,
								height: 1,
								filter: 'sepia(1) hue-rotate(-30deg) brightness(50%)',
								objectFit: 'cover',
								objectPosition: 'center'
							}
						}}
					>
						{image && <Image src={`/api/download${image}`} alt={title ?? ''} width={544} height={360} />}

						{title && (
							<Typography
								component="h3"
								width={1}
								position="absolute"
								px={1}
								fontSize={{ xs: 18, md: 24, lg: 32 }}
								fontWeight={700}
								textAlign="center"
								top="75%"
								left={{ xs: '50%', sm: '40%', md: '50%' }}
								color="#fff"
								zIndex={1}
								sx={{
									cursor: 'default',
									transform: 'translate(-50%, -50%)'
								}}
							>
								{title}
							</Typography>
						)}
					</Grid>

					<Grid size={12} mb={7} px={1.75}>
						{description && (
							<Grid container>
								<Typography variant="body2" lineHeight={1.25} color="common.black">
									{description}
								</Typography>
							</Grid>
						)}

						<Grid container direction="row-reverse" width={1} position="absolute" bottom={0} left={0} mt={1} p={2.5} pt={0}>
							<Grid size="auto">
								<RedButtonAtom>{t('form:button.explore')}</RedButtonAtom>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Link>
		</Grid>
	)
}

export default LearnCardMole
